import { RoomBookingStates } from "~/constants/RoomBooking"

const { ACTIVE, PENDING } = RoomBookingStates

export default (bookings, localePath, getVenue) =>
  bookings.reduce((acc, booking) => {
    // In case state changes 
    // after initial fetch
    if (![ACTIVE, PENDING].includes(booking.state)) return acc
    return acc.concat({
      id: booking.id,
      images: {
        small: booking.room.roomImage.smallPng,
        medium: booking.room.roomImage.mediumPng,
        large: booking.room.roomImage.largePng,
        xlarge: booking.room.roomImage.xlargePng,
      },
      fromDate: booking.startDate,
      toDate: booking.endDate,
      name: booking.room.name,
      house: getVenue(booking.hotel.venue.id).name,
      to: localePath({
        name: "bedrooms-bookings-id",
        params: { id: booking.id },
      }),
    })
  }, [])
